// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__gP7Kv","label":"styles_label__52cEi","caption":"styles_caption__MP8ck","description":"styles_description__rWXC8","content":"styles_content__1UY8Z"};